/** Build selectable reminder table artifact from admin action plan API payload. */

function personName(row) {
  const first = (row.first_name || row.firstName || "").trim();
  const last = (row.last_name || row.lastName || "").trim();
  const full = `${first} ${last}`.trim();
  return full || (row.email || "Participant");
}

function statusLabel(row) {
  const raw = String(row.status || "").trim();
  if (raw === "Pending") return "In progress";
  if (raw === "Not started") return "Not started";
  if (raw === "LiteCompleted") return "LITE completed";
  if (raw === "Completed") return "Fully completed";
  return raw || "—";
}

export function buildReminderRecipientArtifact(data) {
  const flowKind = data?.flow_kind || data?.draft?.flow_kind || "";
  if (data?.action !== "clarify" || flowKind !== "resend_opened_incomplete") {
    return null;
  }
  const invites = data?.draft?.invites || [];
  const rows = invites
    .filter((row) => row && (row.invite_id || row.id))
    .map((row) => ({
      invite_id: String(row.invite_id || row.id),
      participant: personName(row),
      email: (row.email || "").trim(),
      company: (row.company_name || "").trim(),
      role: (row.designation || row.role || "").trim(),
      status: statusLabel(row),
    }));
  if (!rows.length) return null;
  return {
    type: "selectable_table",
    title: "Review before sending",
    selectKey: "invite_id",
    defaultSelected: true,
    confirmLabel: "Send reminders",
    flow_id: data.flow_id || null,
    columns: ["Participant", "Email", "Company", "Status"],
    rows,
  };
}
